import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    programacionesEvaluaciones: [],
    programacionesEvaluacionesPersonal: [],
    idProgramacionEvaluacion: null,
  },

  getters: {
    getProgramacionesEvaluaciones: (state) => state.programacionesEvaluaciones,

    getProgramacionesEvaluacionesPersonal: (state) => state.programacionesEvaluacionesPersonal,

    getIdProgramacionEvaluacion: (state) => state.idProgramacionEvaluacion,
  },

  mutations: {
    SET_PROGRAMACIONES_EVALUACIONES(state, programacionesEvaluaciones) {
      state.programacionesEvaluaciones = programacionesEvaluaciones;
    },

    SET_PROGRAMACIONES_EVALUACIONES_PERSONAL(state, programacionesEvaluacionesPersonal) {
      state.programacionesEvaluacionesPersonal = programacionesEvaluacionesPersonal;
    },

    SET_ID_PROGRAMACION_EVALUACION(state, idProgramacionEvaluacion) {
      state.idProgramacionEvaluacion = idProgramacionEvaluacion;
    },
  },

  actions: {
    async fetchProgramacionesEvaluaciones({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/programacionesevaluaciones')
        .then((response) => {
          commit('SET_PROGRAMACIONES_EVALUACIONES', response.data.data);
        });
    },

    async fetchProgramacionesEvaluacionesByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/programacionesEvaluaciones`)
        .then((response) => {
          commit('SET_PROGRAMACIONES_EVALUACIONES_PERSONAL', response.data.data);
        });
    },

    async saveProgramacionEvaluacion({ commit }, programacionEvaluacion) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${programacionEvaluacion.idExpediente}/programacionesevaluaciones`, programacionEvaluacion)
        .then((response) => {
          commit('SET_ID_PROGRAMACION_EVALUACION', response.data.data[0].ID);
        });
    },

    async updateProgramacionEvaluacion(context, programacionEvaluacion) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/expedientes/${
            programacionEvaluacion.fk_idExpediente
          }/programacionesEvaluaciones/${
            programacionEvaluacion.idProgramacionEvaluacion}`,
          programacionEvaluacion,
        )
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Información de programación guardada correctamente.', {
            root: true,
          });
        });
    },
  },
};
